import { ROLES } from '@/hooks/useNeedRole';

export function getUserRoles(roles: string[] = []) {
  const isAdmin = roles.includes(ROLES.admin);

  const isSiteManager = roles.includes(ROLES.siteManager);

  const isSupport = roles.includes(ROLES.support);

  const isReport = roles.includes(ROLES.report);

  return {
    isAdmin,
    isSiteManager,
    isSupport,
    isReport,
    hasSupportAccess: isAdmin || isSiteManager || isSupport || isReport,
  };
}
